// Helpers puros para ligar nós do canvas arrastando a partir do "+".
// Coordenadas "canvas" são as do conteúdo antes do zoom/pan aplicados via CSS.

export const CONNECTION_DRAG_THRESHOLD = 6;

export const clientToCanvasPoint = (client, rect, viewport) => {
  const zoom = Number(viewport?.zoom) || 1;
  return {
    x: (client.x - (rect?.left || 0) - (Number(viewport?.x) || 0)) / zoom,
    y: (client.y - (rect?.top || 0) - (Number(viewport?.y) || 0)) / zoom,
  };
};

export const outputAnchor = (node, size) => ({
  x: node.position.x + size.width,
  y: node.position.y + size.height / 2,
});

export const inputAnchor = (node, size) => ({
  x: node.position.x,
  y: node.position.y + size.height / 2,
});

// Mesma curva cúbica horizontal usada pelas ligações já existentes.
export const connectionCurvePath = (start, end, minOffset = 90) => {
  const offset = Math.max(minOffset, Math.abs(end.x - start.x) / 2);
  return `M ${start.x} ${start.y} C ${start.x + offset} ${start.y}, ${end.x - offset} ${end.y}, ${end.x} ${end.y}`;
};

export const hasMovedBeyond = (
  origin,
  current,
  threshold = CONNECTION_DRAG_THRESHOLD
) =>
  Math.hypot(current.x - origin.x, current.y - origin.y) >=
  Math.max(0, threshold);

// Retorna o nó mais acima (último renderizado) sob o ponto, com tolerância
// para incluir a alça de entrada que fica fora da borda esquerda do cartão.
export const findNodeAtPoint = (nodes, point, size, { padding = 16 } = {}) => {
  for (let index = nodes.length - 1; index >= 0; index -= 1) {
    const node = nodes[index];
    const { x, y } = node.position;
    if (
      point.x >= x - padding &&
      point.x <= x + size.width + padding &&
      point.y >= y - padding &&
      point.y <= y + size.height + padding
    ) {
      return node;
    }
  }
  return null;
};

// Regras de ligação: sem auto-ligação e sem ligação duplicada.
export const canConnectNodes = (edges, sourceId, targetId) => {
  if (!sourceId || !targetId || sourceId === targetId) return false;
  return !(edges || []).some(
    edge => edge.source === sourceId && edge.target === targetId
  );
};
